import PropTypes from 'prop-types';

const historyShape = PropTypes.shape({
  location: PropTypes.object.isRequired,
  push: PropTypes.func.isRequired,
});

export default historyShape;
